import { usePartnerConfig } from '@portals/api/partners';
import { useCurrentUser } from '@portals/api/ui';

export function useCanAccessPersonalSettings() {
  const partnerConfig = usePartnerConfig();
  const currentUser = useCurrentUser();

  return currentUser.data?.partner_id === partnerConfig?.id;
}
